import React from "react";
import PropTypes from "prop-types";

import { Cargando, EstadoVacio } from "../components/Estados";
import ListaGestion from "./ListaGestion";

import { useConsulta } from "../hooks/useConsulta";
import { obtenerPeriodosGestion } from "../services/bibliotecaApi";

/**
 * Pestaña Procesos de Gestion Biblioteca: directo a la tabla, con tipo,
 * estado y periodo en selectores, como en Procesos del solicitante. Antes se
 * elegia el tipo en tarjetas (cambiado el 2026-10-19). Desde la tabla, cada
 * solicitud se abre o se gestiona en un modal, como en Gestion Practicas.
 *
 * Aqui se ven las solicitudes que cada gestor puede ver segun sus permisos.
 */
const ProcesosGestion = ({ onMensaje }) => {
  const periodos = useConsulta(obtenerPeriodosGestion, [], null);

  if (periodos.cargando) return <Cargando />;
  // Tambien llega aqui quien no administra el modulo: el backend responde
  // 403 y explica por que.
  if (periodos.error) return <EstadoVacio mensaje={periodos.error.message} />;

  return <ListaGestion periodos={periodos.datos} onMensaje={onMensaje} />;
};

ProcesosGestion.propTypes = {
  onMensaje: PropTypes.func.isRequired,
};

export default ProcesosGestion;
